/**
 * Sends the browser to Auth0 login, returning to `returnTo` (defaults to the current path) after sign-in.
 *
 * `connection` is an Auth0 connection name resolved from a partner's `?tenant=` alias
 * (see `tenantConnection.ts`). `@auth0/nextjs-auth0` v4 forwards every `/auth/login` query parameter
 * except `returnTo` straight through to Auth0's `/authorize`, so setting it here is all that is needed
 * to skip the connection picker. Omit it and login behaves exactly as before.
 *
 * Deliberately does **not** set `scope` or `audience`: both are already configured on the shared
 * `Auth0Client`, and a per-request `scope` would override the client default and drop
 * `read:calculate` — which the API's CustomerCalculate policy requires, so every pricing call would
 * start failing with 403 for exactly the partners routed through here.
 */
export function redirectToLogin(returnTo?: string, connection?: string): void {
  const loginUrl = new URL("/auth/login", window.location.origin);
  loginUrl.searchParams.set("returnTo", returnTo ?? window.location.pathname);
  if (connection) {
    loginUrl.searchParams.set("connection", connection);
  }
  window.location.assign(loginUrl.toString());
}
